// extracted by mini-css-extract-plugin
export default {"relyingPartiesTable":"relying-parties-table-container__relying-parties-table__qQRUY","relyingPartiesSmallTable":"relying-parties-table-container__relying-parties-small-table__ULMya"};